import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const ProgressBarContainer = styled.div`
  background: #e2e8f0;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
  width: 100%;
  margin-top: 0.5rem;
  position: relative;
`;

const ProgressFill = styled(motion.div)`
  background: ${props => props.complete ? 'linear-gradient(90deg, #10b981 0%, #059669 100%)' : 'linear-gradient(90deg, #ffb53d 0%, #f59e0b 100%)'};
  height: 100%;
  border-radius: 3px;
  transition: background 0.3s ease;
`;

function ProgressBar({ progress }) {
  const normalizedProgress = Math.min(100, Math.max(0, progress));
  const isComplete = normalizedProgress >= 100;
  
  return (
    <ProgressBarContainer>
      <ProgressFill
        initial={{ width: 0 }}
        animate={{ width: `${normalizedProgress}%` }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        complete={isComplete}
      />
    </ProgressBarContainer>
  );
}

export default ProgressBar;
